module.exports = __webpack_public_path__ + "static/media/design2.9f480b29.gif";